import { jsx as _jsx } from "react/jsx-runtime";
import MP3 from './mp3';
const Audio = () => {
    return _jsx(MP3, {});
};
Audio.iconName = 'Audio Icon';
export default Audio;
